import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface Unit {
  id: string;
  name: string;
  /** OKR Tracker field — UID of the user who leads this unit. */
  leadUserId?: string;
  /** Optional per-project overrides for cross-functional units. */
  leadByProject?: Record<string, string>;
  isCrossProject?: boolean;
}

/**
 * Fetch the shared `/units` collection — same source as OKR Tracker's
 * Lead Dept resolution + EPR's panel suggestion. Sorted alphabetically.
 *
 * Used by Account Portal's invite/edit flows so admin can assign a unit
 * to a new user from a single canonical list (no manual ID typing).
 */
export async function fetchAllUnits(): Promise<Unit[]> {
  const snap = await getDocs(query(collection(db, 'units'), orderBy('name')));
  return snap.docs.map(d => ({ id: d.id, ...(d.data() as Omit<Unit, 'id'>) }));
}
